const TITAN_CLIENT_ID = '606514f519249fe0becb8be8dc8ca5fb'
const CLIENT_REGISTRATION_ID = 'c809c320-9676-4637-be0c-a2c62d8b927d'
const SERVER_REGISTRATION_ID = 'd8e6b2fe-9615-46f3-bcc2-36521fb42303'

export const states = ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY']
export const statesWithLabels = [{ label: 'Alabama', value: 'AL' }, { label: 'Alaska', value: 'AK' }, { label: 'Arizona', value: 'AZ' }, { label: 'Arkansas', value: 'AR' }, { label: 'California', value: 'CA' }, { label: 'Colorado', value: 'CO' }, { label: 'Connecticut', value: 'CT' }, { label: 'Delaware', value: 'DE' }, { label: 'Florida', value: 'FL' }, { label: 'Georgia', value: 'GA' }, { label: 'Hawaii', value: 'HI' }, { label: 'Idaho', value: 'ID' }, { label: 'Illinois', value: 'IL' }, { label: 'Indiana', value: 'IN' }, { label: 'Iowa', value: 'IA' }, { label: 'Kansas', value: 'KS' }, { label: 'Kentucky', value: 'KY' }, { label: 'Louisiana', value: 'LA' }, { label: 'Maine', value: 'ME' }, { label: 'Maryland', value: 'MD' }, { label: 'Massachusetts', value: 'MA' }, { label: 'Michigan', value: 'MI' }, { label: 'Minnesota', value: 'MN' }, { label: 'Mississippi', value: 'MS' }, { label: 'Missouri', value: 'MO' }, { label: 'Montana', value: 'MT' }, { label: 'Nebraska', value: 'NE' }, { label: 'Nevada', value: 'NV' }, { label: 'New Hampshire', value: 'NH' }, { label: 'New Jersey', value: 'NJ' }, { label: 'New Mexico', value: 'NM' }, { label: 'New York', value: 'NY' }, { label: 'North Carolina', value: 'NC' }, { label: 'North Dakota', value: 'ND' }, { label: 'Ohio', value: 'OH' }, { label: 'Oklahoma', value: 'OK' }, { label: 'Oregon', value: 'OR' }, { label: 'Pennsylvania', value: 'PA' }, { label: 'Rhode Island', value: 'RI' }, { label: 'South Carolina', value: 'SC' }, { label: 'South Dakota', value: 'SD' }, { label: 'Tennessee', value: 'TN' }, { label: 'Texas', value: 'TX' }, { label: 'Utah', value: 'UT' }, { label: 'Vermont', value: 'VT' }, { label: 'Virginia', value: 'VA' }, { label: 'Washington', value: 'WA' }, { label: 'West Virginia', value: 'WV' }, { label: 'Wisconsin', value: 'WI' }, { label: 'Wyoming', value: 'WY' }]
export const CERTIFICATION_EXPIRY_WARNING_DAYS = 7

export const requiredScalingRegionStates = ['WA', 'ID', 'CA', 'OR', 'MT', 'WY', 'CO', 'UT', 'AK']

export const INITIAL_TIMEZONE_OFFSET = 999

export default {
  TITAN_CLIENT_ID,
  CLIENT_REGISTRATION_ID,
  SERVER_REGISTRATION_ID
}

export const ErrorCodes = {
  INVALID_MT_CONFIGURATION: 'INVALID_MT_CONFIGURATION',
  NO_TENANTS_CONFIGURED: 'NO_TENANTS_CONFIGURED',
  ADMIN_CONSENT_NOT_GRANTED: 'ADMIN_CONSENT_NOT_GRANTED'
}

export const ExportBatchArchivePathSegments = {
  // AP
  logsSettlementsByPayee: 'logs-settlements-by-payee',
  byproductSettlementsByPayee: 'bp-settlements-by-payee',
  logsPaymentRegister: 'logs-payment-register',
  byproductPaymentRegister: 'bp-payment-register',
  logsProductionSummary: 'logs-production-summary',

  // AR
  logsReceivablesRegister: 'logs-receivables-register',
  byproductReceivablesRegister: 'bp-receivables-register',

  // JE
  logsAccrualRegiseter: 'logs-accrual-register',
  byproductAccrualRegister: 'bp-accraul-register'
}

export const Pagination = {
  DefaultPageSize: 100,
  MaxPageSize: 500
}

export const TicketBookConstants = {
  MaxNewPagesPerBook: 100,
  ItemsPerPageOptions: [10, 15]
}

export const NumericConstants = {
  ShortTonDivisor: 2000,
  MetricTonDivisor: 2204.62,
  MbfDivisor: 1000
}

export const SupportedReceiverCountries = [
  {
    countryCode: 'US'
  }
]

export const StringConstants = {
  ExtraShortStringLength: 5,
  ShortStringLength: 10,
  MediumStringLength: 32,
  IpAddressMaxLength: 40,
  LongStringLength: 64,
  ExtraLongStringLength: 128,
  ExtraExtraLongStringLength: 256,
  ExtraExtraExtraLongStringLength: 512,
  SuperLongStringLength: 1024,
  ExtraSuperLongStringLength: 2048,
  MaxFixedStringLength: 4000
}
